import type { IServiceColumn } from "../functions/serviceViewmodel";

/**
 * Provider attributes shown in the "Service Provider" section of the service
 * report info card (ServiceReportInfoCard.vue).
 *
 * Part of the persisted "directory" configuration (key:
 * serviceProviderReportColumns). Paths are relative to the ServiceProviders
 * record - the selection builder prefixes them with
 * dataModel.providerRefOnService, so the ref name itself stays configurable
 * ("service_providers" here, "biobank" in the older BBMRI-ERIC model).
 *
 * `refFields` is mandatory wherever the referenced table has no `label`
 * column: EMX2 fails the whole query on a single unknown subfield. Networks
 * only has `name`, Persons has `full_name`, Beneficiaries has neither.
 *
 * Defaults cover every real ServiceProviders field in the isidore-acc-v13
 * model except `services` (the refback back to this page's own service).
 */
export const initialServiceProviderReportColumns: IServiceColumn[] = [
  { label: "Name:", column: "name" },
  { label: "Acronym:", column: "acronym" },
  { label: "Research Infrastructure:", column: "research_infrastructure" },
  { label: "Description:", column: "description", type: "longtext" },
  { label: "Website:", column: "url", type: "hyperlink" },
  { label: "Juridical person:", column: "juridical_person" },
  { label: "Country:", column: "country", type: "ref" },
  { label: "Location:", column: "location" },
  { label: "Latitude:", column: "latitude" },
  { label: "Longitude:", column: "longitude" },
  { label: "Head/PI:", column: "head", type: "ref", refFields: ["full_name"] },
  {
    label: "Contact:",
    column: "contact",
    type: "ref",
    refFields: ["full_name"],
  },
  { label: "Contact email:", column: "contact.email", type: "email" },
  { label: "Networks:", column: "network", type: "mref", refFields: ["name"] },
  {
    label: "National node:",
    column: "national_node",
    type: "ref",
    refFields: ["id", "description"],
  },
  { label: "Commercial collaboration:", column: "collaboration_commercial", type: "bool" },
  {
    label: "Not-for-profit collaboration:",
    column: "collaboration_non_for_profit",
    type: "bool",
  },
  { label: "Withdrawn:", column: "withdrawn", type: "bool" },
  {
    label: "PID:",
    column: "pid",
    showCopyIcon: true,
    copyValuePrefix: "http://hdl.handle.net/",
  },
  { label: "Service Provider id:", column: "id" },
];

export default initialServiceProviderReportColumns;
